import { createSlice } from "@reduxjs/toolkit";
import { HOME_ARTICLES } from "../../db/data";


const initialState = { home:[] };
const homeSlice = createSlice(
    {
        name: "home",
        initialState,
        reducers: {
            loadHome: (state, action) => {
                state.home = HOME_ARTICLES;
            },
            addHomeArticle: (state,action) => {
                state.home.push(action.payload);
            }            
        }
    }
);

//export action creator and state slice
export const { loadHome, addHomeArticle } = homeSlice.actions
export const selectGallery = state => state.home;

//export slice reducer
export default homeSlice.reducer;